import {
  createBrowserRouter,
  createRoutesFromElements,
  Outlet,
  Route,
  RouterProvider
} from 'react-router';
import { NavBar, SignIn, SignUp, UserDashboard, AdminDashboard, Hero, CarTypes, Services, Memberships, About, Contact, Footer, GiftCards } from './components/components.js';
import { Booking, ContactPage, ServicesPage } from './pages/pages.js';
import { AuthProvider, BookingProvider, UserBookingProvider, GiftCardProvider, MembershipProvider, CalendarProvider } from './context/contexts.js';
import ProtectedRoute from './routes/ProtectedRoute.jsx';
import PublicRoute from './routes/PublicRoute.jsx';
import ErrorBoundary from './routes/ErrorBoundary.jsx';
import { Toaster } from 'sonner';
import './App.css';

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route
      element={
        <>
          <NavBar />
          <div className='main-content'>
            <Outlet />
          </div>
          <Footer />
        </>
      }
      errorElement={<ErrorBoundary />}
    >
      {/* Public Routes */}
      <Route path="/signin" element={
        <PublicRoute>
          <SignIn />
        </PublicRoute>
      } />
      <Route path="/signup" element={
        <PublicRoute>
          <SignUp />
        </PublicRoute>
      } />

      {/* Protected Routes */}
      <Route path="/user" element={
        <ProtectedRoute>
          <UserDashboard />
        </ProtectedRoute>
      } />
      <Route path="/admin/*" element={
        <ProtectedRoute requireAdmin>
          <AdminDashboard />
        </ProtectedRoute>
      } />

      {/* Unrestricted Routes */}
      <Route
        index
        element={
          <>
            <Hero />
            <CarTypes />
            <Services />
            <About />
            <Contact />
          </>
        }
      />
      <Route path="/services" element={<ServicesPage />} />
      <Route path="/booking" element={<Booking />} />
      <Route path="/memberships" element={<Memberships />} />
      <Route path="/giftcards" element={<GiftCards />} />
      <Route path="/contact" element={<ContactPage />} />

      {/* Catch-all route for 404s */}
      <Route path="*" element={<ErrorBoundary />} />
    </Route>
  )
);

function App() {
  return (
    <div className="App">
      <Toaster />
      <div className='container'>
        <AuthProvider>
          <CalendarProvider>
            <BookingProvider>
              <UserBookingProvider>
                <GiftCardProvider>
                  <MembershipProvider>
                    <RouterProvider router={router} />
                  </MembershipProvider>
                </GiftCardProvider>
              </UserBookingProvider>
            </BookingProvider>
          </CalendarProvider>
        </AuthProvider>
      </div>
    </div>
  );
}

export default App;
